export default __webpack_public_path__ + "static/media/iconfinder_html5_334656.7db0ca75.png";